import type { PartnerConfig } from "@/content/partners/types"
import { studioEsmalteriaDelicadaPartnerConfig } from "@/content/partners/studio-esmalteria-delicada"
import { avancoPartnerConfig } from "@/content/partners/avanco"
import { buserPartnerConfig } from "@/content/partners/buser"
import { exploraEbikeFestivalPartnerConfig } from "@/content/partners/explora-ebike-festival"
import { fasminasPartnerConfig } from "@/content/partners/fasminas"
import { feijoadaSolidariaPartnerConfig } from "@/content/partners/feijoada-solidaria"
import { monkeysFestRide2026PartnerConfig } from "@/content/partners/monkeys-fest-ride-2026"
import { ibhPartnerConfig } from "@/content/partners/ibh"
import { mercadoNovoPartnerConfig } from "@/content/partners/mercado-novo"
import { parcelarPartnerConfig } from "@/content/partners/parcelar"
import { parkClubPartnerConfig } from "@/content/partners/park-club"
import { portalCaminhoDasMontanhasPartnerConfig } from "@/content/partners/portal-caminho-das-montanhas"
import { pcyclePartnerConfig } from "@/content/partners/pcycle"
import { sinservesPartnerConfig } from "@/content/partners/sinserves"
import { vienaPartnerConfig } from "@/content/partners/viena"

const PARTNERS_BY_SLUG: Record<string, PartnerConfig> = {
  [studioEsmalteriaDelicadaPartnerConfig.slug]: studioEsmalteriaDelicadaPartnerConfig,
  [avancoPartnerConfig.slug]: avancoPartnerConfig,
  [buserPartnerConfig.slug]: buserPartnerConfig,
  [exploraEbikeFestivalPartnerConfig.slug]: exploraEbikeFestivalPartnerConfig,
  [fasminasPartnerConfig.slug]: fasminasPartnerConfig,
  [feijoadaSolidariaPartnerConfig.slug]: feijoadaSolidariaPartnerConfig,
  [monkeysFestRide2026PartnerConfig.slug]: monkeysFestRide2026PartnerConfig,
  [ibhPartnerConfig.slug]: ibhPartnerConfig,
  [mercadoNovoPartnerConfig.slug]: mercadoNovoPartnerConfig,
  [parcelarPartnerConfig.slug]: parcelarPartnerConfig,
  [parkClubPartnerConfig.slug]: parkClubPartnerConfig,
  [portalCaminhoDasMontanhasPartnerConfig.slug]: portalCaminhoDasMontanhasPartnerConfig,
  [pcyclePartnerConfig.slug]: pcyclePartnerConfig,
  [sinservesPartnerConfig.slug]: sinservesPartnerConfig,
  [vienaPartnerConfig.slug]: vienaPartnerConfig,
}

export function isHomeClonePartner(config: PartnerConfig | null | undefined): boolean {
  return config?.landingVariant === "home_clone"
}

export function getPartnerConfigBySlug(slug: string | null | undefined): PartnerConfig | null {
  if (!slug || typeof slug !== "string") return null
  const normalized = slug.trim().toLowerCase()
  if (!normalized) return null
  return PARTNERS_BY_SLUG[normalized] ?? null
}

export function listPartnerConfigs(): PartnerConfig[] {
  return Object.values(PARTNERS_BY_SLUG)
}
